module.exports = __webpack_public_path__ + "media/application/images/svgs/arrow-right-6fcfb88c9854df6afc771e6c41b32e44.svg";